<div class="contactUs f-p">
  <div class="container-xl">
    <p class="f-m">Contact us</p>
    <h1
      data-aos="fade-down"
      data-aos-duration="1000"
      data-aos-easing="ease-in-sine"
      class="smb5 sfont48">
      We’d love to hear from you
    </h1>
    <div class="row align-items-centers contactUs--row">
      <div
        class="col-sm-12 col-md-4 smy2"
        data-aos="fade-right"
        data-aos-duration="1000"
        data-aos-easing="ease-in-sine">
        <div class="contactUs--each">
          <h5 class="smt1 smb4">Headquarters</h5>
          <div class="row">
            <div class="col-auto">
              <img src="./../../../assets/images/location.png" alt="" />
            </div>
            <div class="col-auto">Southlake, TX 76092 <br /></div>
          </div>
          <h5 class="smt4 smb2">Email us</h5>
          <div class="row align-items-centers">
            <div class="col-auto">
              <img src="./../../../assets/images/mail-icon.png" alt="" />
            </div>
            <div class="col-auto">
              <a href="mailto:sales@kunnect.com"> sales&#64;ikunnect.com </a>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-sm-12 col-md-4 smy2"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-easing="ease-in-sine">
        <div class="contactUs--each">
          <h5 class="smt1 smb4">Call us</h5>
          <div class="row smb4">
            <div class="col-auto">
              <img src="./../../../assets/images/phone-icon.png" alt="" />
            </div>
            <div class="col-auto">
              877-iKunnect <br />
              1 (877) 586-6328
            </div>
          </div>
          <div class="row">
            <div class="col-auto">
              <img src="./../../../assets/images/phone-icon.png" alt="" />
            </div>
            <div class="col-auto">
              LOCAL NUMBER <br />
              1 (469) 946-9242
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-sm-12 col-md-4 smy2"
        data-aos="fade-left"
        data-aos-duration="1000"
        data-aos-easing="ease-in-sine">
        <div class="contactUs--each">
          <h5 class="smt1 smb4">Follow us</h5>
          <div class="column">
            <div class="col">
              <img src="./../../../assets/images/facebook.png" alt="" />
              Facebook
            </div>
            <div class="col smy3">
              <a href="https://x.com/iKunnect" target="_blank">
                <img src="./../../../assets/images/twitter.png" alt="Twitter" />
                Twitter
              </a>
            </div>
            <div class="col">
              <img src="./../../../assets/images/blogger.png" alt="" /> Blogger
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      class="primaryBtn md sfont13 smt5"
      data-aos="fade-up"
      data-aos-duration="2000"
      (click)="isChatEnabled = true">
      LET'S CHAT
    </button>
  </div>
  <app-lets-chat *ngIf="isChatEnabled"></app-lets-chat>
</div>
